import styled from 'styled-components';

import PrimaryButton from '../../components/atoms/primary-button/PrimaryButton';

import mq from '../../styles/breakpoints';
import Colors from '../../styles/colors';

export const ButtonContainer = styled.div<{ showLine?: boolean }>`
  border-top: ${({ showLine }) =>
    showLine ? `1px solid ${Colors.abnNeutralsN65}` : 'none'};
  margin-top: ${({ showLine }) => (showLine ? '40px' : '0')};
  padding-top: 24px;
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  box-sizing: border-box;
  justify-content: center;
  margin-bottom: 16px;
  margin-right: 0;
  width: 100%;

  ${mq.from.breakpoint.M`
    width: auto;
    margin-bottom: 0;
    margin-right: 32px;
  `}

  > div {
    ${mq.from.breakpoint.L`
      padding: 0 20px;
    `}
  }
`;
